import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'

import { selectProgramType } from '../../configuration/selectors/selectProgramType'

import { selectSectionSettings } from './selectSectionSettings'

export const selectIsPowerServicesParticipant = createSelector(
  [selectSectionSettings, selectProgramType],
  (sectionSettings, programType) => {
    switch (programType) {
      case ProgramTypes.CorePrint:
        return isSectionSettingOn(sectionSettings.CorePrintPowerServicesMembershipParticipant)
      case ProgramTypes.PersonalSystems:
        return isSectionSettingOn(sectionSettings.PersonalSystemsPowerServicesMembershipParticipant)
      default:
        return false
    }
  }
)
